module.exports = __webpack_public_path__ + "static/market-index-treemap-c2f0a43e9eeb841ec0f6e99e06a7af63.png";